import { Component } from "react";
import { connect } from "react-redux";
import { submitOrEditAbsence, submitOrEditAsDraft, cancel } from "../../../redux/absences/absencesEditionActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import "../../../utils.css";
import FooterFixedOnScreen from "../../../containers/Layout/FooterFixedOnScreen";

class CreateAbsence extends Component {
    submitOrEditAbsence() {
        this.props.submitOrEditAbsence(this.props.absences, this.props.activeUser);
    }

    submitOrEditAsDraft() {
        this.props.submitOrEditAsDraft(this.props.absences, this.props.activeUser);
    }

    cancel() {
        this.props.cancel(this.props.absences, this.props.activeUser);
    }

    render() {
        return (
            <FooterFixedOnScreen>
                <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-4 col-4">
                        <Fab onClick={this.submitOrEditAbsence.bind(this)} color="primary" className="div-center">
                            <Icon>send</Icon>
                        </Fab>
                        <span className="floating-btn-text span-center">Soumettre</span>
                    </div>
                    <div className="offset-lg-3 col-lg-2 offset-md-3 col-md-2 col-sm-4 col-4">
                        <div className="center">
                            <Fab onClick={this.submitOrEditAsDraft.bind(this)} color="secondary" className="div-center">
                                <Icon>save</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">Brouillon</span>
                        </div>
                    </div>
                    <div className="offset-lg-3 col-lg-2 offset-md-3 col-md-2 col-sm-4 col-4">
                        <div className="center">
                            <Fab onClick={this.cancel.bind(this)} className="red-button div-center">
                                <Icon>block</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">Annuler</span>
                        </div>
                    </div>
                </div>
            </FooterFixedOnScreen>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        submitOrEditAbsence: (absencesState, activeUser) => dispatch(submitOrEditAbsence(absencesState, activeUser)),
        submitOrEditAsDraft: (absencesState, activeUser) => dispatch(submitOrEditAsDraft(absencesState, activeUser)),
        cancel: (absencesState, activeUser) => dispatch(cancel(absencesState, activeUser)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CreateAbsence);
